import { render } from "./clinic-changepassword.vue?vue&type=template&id=5bc24024&scoped=true"
import script from "./clinic-changepassword.vue?vue&type=script&lang=js"
export * from "./clinic-changepassword.vue?vue&type=script&lang=js"

import "./clinic-changepassword.vue?vue&type=style&index=0&id=5bc24024&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc24024"]])

export default __exports__